import './scss/index.scss';

import ComponentsFactory from 'foundation/components-factory';
import QualifiedPlayersListingComponent from './js/qualified-players-listing.component';

ComponentsFactory.getInstance().define('qualified-players-listing', QualifiedPlayersListingComponent);
